let booksData = [
    // {
    //     id: 1,
    //     bookName :"The Great Gatsby",
    //     topic :"Novel",
    //     pages :"100",
    //     writer :"F. Scott Fitzgerald",
    //     description : "The Great Gatsby is a 1925 novel by American writer F. Scott Fitzgerald. Set in the Jazz Age on Long Island, near New York City, the novel depicts first-person narrator Nick Carraway's interactions with mysterious millionaire Jay Gatsby and Gatsby's obsession to reunite with his former lover, Daisy Buchanan."
    // },
    // {
    //     id: 2,
    //     bookName :"Don Quixote",
    //     topic :"Epic Novel",
    //     pages :"120",
    //     writer :"Miguel de Cervantes",
    //     description :"Don Quixote is a Spanish epic novel by Miguel de Cervantes. It was originally published in two parts, in 1605 and 1615. Considered a founding work of Western literature, it is often labelled as the first modern novel and one of the greatest works ever written."
    // },
    // {
    //     id: 3,
    //     bookName :"One Hundred Years of Solitude",
    //     topic :"Novel",
    //     pages :"200",
    //     writer :"Gabriel García Márquez",
    //     description : "One Hundred Years of Solitude is a 1967 novel by Colombian author Gabriel García Márquez that tells the multi-generational story of the Buendía family, whose patriarch, José Arcadio Buendía, founded the fictitious town of Macondo. The novel is often cited as one of the supreme achievements in world literature."
    // }
];
export default booksData;